import { useContext, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { UserContext } from '../../App';
import { includesPermission } from '../../utils/utils';

const auth0Namespace = process.env.REACT_APP_AUTH0_NAMESPACE;
const permissionsNamespace = auth0Namespace + 'permissions';

// REMOVE(settings-users-and-access): Delete when legacy Auth0 token permissions are retired.
function useLegacyTokenPermission({ permission, defaultValue = false, skip = false }) {
  const [hasPermission, setHasPermission] = useState(!!defaultValue);
  const { getIdTokenClaims } = useAuth0();
  const { currentOrgId } = useContext(UserContext);

  useEffect(() => {
    if (skip) {
      setHasPermission(!!defaultValue);
      return;
    }

    let cancelled = false;

    async function loadPermission() {
      const token = await getIdTokenClaims();
      if (cancelled) return;
      setHasPermission(includesPermission(token?.[permissionsNamespace], permission));
    }

    loadPermission();

    return () => {
      cancelled = true;
    };
  }, [skip, permission, defaultValue, currentOrgId, getIdTokenClaims]);

  return hasPermission;
}

export default useLegacyTokenPermission;
